import { useState, useEffect, useCallback } from 'react';
import { getToken } from '../../utils/secureStorage';
import { APP_VERSION } from '../../services/updateService';
import './AdminAppVersions.css';

const SITE = (process.env.REACT_APP_SITE_URL || 'https://yadoo20.ir').replace(/\/+$/, '');
const API  = (process.env.REACT_APP_API_URL  || `${SITE}/api`).replace(/\/+$/, '');

const userOf = () => {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
};

export default function AdminAppVersions() {
  const user = userOf();
  const [apks, setApks] = useState([]);
  const [current, setCurrent] = useState(null);
  const [serverVersion, setServerVersion] = useState(null);
  const [form, setForm] = useState({ message: '', forceUpdate: false, apkUrl: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);

  const h = () => ({
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  });

  const load = useCallback(async () => {
    setErr('');
    try {
      const [a, v, s] = await Promise.all([
        fetch(`${API}/admin/apk/list`, { headers: h() }).then(r => r.json()).catch(() => []),
        fetch(`${API}/public/app-update?t=${Date.now()}`, { cache: 'no-store' }).then(r => r.json()).catch(() => ({ active: false })),
        fetch(`${API}/admin/server-version`, { headers: h() }).then(r => r.json()).catch(() => ({ version: null })),
      ]);
      setApks(Array.isArray(a) ? a : []);
      setCurrent(v?.active ? v : null);
      setServerVersion(s?.version || null);
    } catch {
      setErr('خطا در بارگذاری اطلاعات');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.name.toLowerCase().endsWith('.apk')) {
      return setErr('فقط فایل با پسوند .apk مجاز است');
    }
    if (f.size > 200 * 1024 * 1024) {
      return setErr('حجم فایل بیش از ۲۰۰ مگابایت است');
    }
    setUploading(true);
    setErr('');
    try {
      const fd = new FormData();
      fd.append('apk', f);
      const r = await fetch(`${API}/admin/apk/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        body: fd,
      });
      const d = await r.json();
      if (d.success) {
        await load();
        setForm(x => ({ ...x, apkUrl: d.url }));
      } else {
        setErr(d.error || 'خطا در آپلود');
      }
    } catch {
      setErr('خطای شبکه در آپلود');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const del = async (filename) => {
    if (!window.confirm(`حذف فایل «${filename}»؟\n\nاگر این فایل در اعلام فعال استفاده شده، لینک آن ۴۰۴ می‌شود.`)) {
      return;
    }
    try {
      const r = await fetch(`${API}/admin/apk/delete`, {
        method: 'POST',
        headers: h(),
        body: JSON.stringify({ filename }),
      });
      if (!r.ok) {
        setErr('خطا در حذف فایل');
        return;
      }
      // اگر فایلی که حذف شد، در form یا current استفاده شده، پاک کن
      const url = `/media/apk/${filename}`;
      if (form.apkUrl === url) setForm(x => ({ ...x, apkUrl: '' }));
      if (current?.apkUrl === url) {
        setErr('توجه: فایلی که در اعلام فعال استفاده شده بود حذف شد. لطفاً یک APK جدید انتخاب و دوباره منتشر کنید.');
      }
      load();
    } catch {
      setErr('خطای شبکه در حذف');
    }
  };

  const publish = async () => {
    setErr('');
    if (!form.message.trim()) {
      return setErr('پیام نمی‌تواند خالی باشد');
    }
    if (form.message.length > 300) {
      return setErr('پیام حداکثر ۳۰۰ کاراکتر');
    }

    if (!serverVersion) {
      return setErr(
        'نسخه‌ی سرور خوانده نشد. مطمئن شوید:\n' +
        '• package.json کنار server.js روی سرور هست\n' +
        '• deploy انجام شده'
      );
    }

    if (APP_VERSION !== serverVersion) {
      return setErr(
        `نسخه‌ی باندل مرورگر شما (${APP_VERSION}) با نسخه‌ی deploy شده روی سرور (${serverVersion}) فرق دارد.\n\n` +
        `دو علت ممکن است:\n` +
        `۱. مرورگر شما باندل قدیمی را لود کرده → صفحه را رفرش کنید (Ctrl+Shift+R)\n` +
        `۲. package.json روی سرور به‌روز نشده → آن را کنار server.js کپی کنید`
      );
    }

    const isReannounce = current && current.version === APP_VERSION;
    const confirmMsg = isReannounce
      ? `اعلام فعلی نسخه ${APP_VERSION} را با پیام جدید به‌روزرسانی کنیم؟`
      : `انتشار نسخه ${APP_VERSION} برای همه‌ی کاربران؟\n\n` +
        (form.forceUpdate ? '⚠️ این اعلام اجباری است.' : 'این اعلام اختیاری است.');
    if (!window.confirm(confirmMsg)) return;

    setBusy(true);
    try {
      const body = {
        id: 'current',
        active: true,
        version: APP_VERSION,
        message: form.message.trim(),
        forceUpdate: !!form.forceUpdate,
        apkUrl: form.apkUrl || null,
        publishedAt: new Date().toISOString(),
        publishedBy: user?.id || null,
      };
      const res = await fetch(`${API}/db/appUpdate/current`, {
        method: 'PUT',
        headers: h(),
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        setErr('خطا در انتشار (' + res.status + ')');
        return;
      }
      setForm({ message: '', forceUpdate: false, apkUrl: '' });
      load();
    } catch {
      setErr('خطای شبکه در انتشار');
    } finally {
      setBusy(false);
    }
  };

  const deactivate = async () => {
    if (!window.confirm('لغو اعلام؟ دیگر به کاربران نمایش داده نمی‌شود.')) return;
    try {
      await fetch(`${API}/db/appUpdate/current`, {
        method: 'PUT',
        headers: h(),
        body: JSON.stringify({
          id: 'current',
          active: false,
          version: current?.version || APP_VERSION,
          message: current?.message || '',
          forceUpdate: false,
          apkUrl: current?.apkUrl || null,
          publishedAt: new Date().toISOString(),
          publishedBy: user?.id || null,
        }),
      });
      load();
    } catch {
      setErr('خطای شبکه در لغو اعلام');
    }
  };

  const versionMismatch = APP_VERSION !== serverVersion;
  const canPublish = !busy && !versionMismatch && !!serverVersion;

  if (loading) {
    return (
      <div className="aav-page" dir="rtl">
        <h2 className="aav-title">مدیریت به‌روزرسانی</h2>
        <div className="aav-empty">در حال بارگذاری…</div>
      </div>
    );
  }

  return (
    <div className="aav-page" dir="rtl">
      <h2 className="aav-title">مدیریت به‌روزرسانی</h2>

      {err && <div className="aav-error">{err}</div>}

      {/* ===================== کارت وضعیت ===================== */}
      <div className="aav-status-card">
        <div className="aav-status-row">
          <b>نسخه‌ی باندل مرورگر شما:</b>
          <code>{APP_VERSION}</code>
        </div>
        <div className="aav-status-row">
          <b>نسخه‌ی deploy شده روی سرور:</b>
          <code>{serverVersion || '—'}</code>
        </div>

        {versionMismatch && (
          <div className="aav-warning">
            ⚠️ نسخه‌ها یکی نیست. یا صفحه را رفرش کنید (Ctrl+Shift+R) یا{' '}
            <code>package.json</code> را روی سرور به‌روز کنید.
          </div>
        )}

        <div className="aav-current">
          {current ? (
            <div className="aav-current-active">
              <div>
                <b>اعلام فعال:</b> ✓ نسخه {current.version}{' '}
                ({current.forceUpdate ? 'اجباری' : 'اختیاری'})
              </div>
              <div><b>پیام:</b> {current.message}</div>
              {current.apkUrl && (
                <div><b>APK:</b> <code>{current.apkUrl}</code></div>
              )}
              <button className="aav-deactivate-btn" onClick={deactivate}>
                لغو اعلام
              </button>
            </div>
          ) : (
            <div className="aav-current-empty">هیچ اعلام فعالی نیست</div>
          )}
        </div>
      </div>

      {/* ===================== آپلود APK ===================== */}
      <h3 className="aav-section-title">فایل‌های APK</h3>
      <div className="aav-upload-row">
        <input
          type="file"
          accept=".apk"
          onChange={upload}
          disabled={uploading}
          className="aav-file-input"
        />
        {uploading && <span className="aav-uploading">در حال آپلود…</span>}
      </div>

      {apks.length === 0 ? (
        <div className="aav-empty">هیچ فایل APK آپلود نشده</div>
      ) : (
        <ul className="aav-apk-list">
          {apks.map(a => (
            <li key={a.filename} className="aav-apk-item">
              <div className="aav-apk-info">
                <code className="aav-apk-name">{a.filename}</code>
                <span className="aav-apk-size">
                  ({(a.size / 1024 / 1024).toFixed(1)} MB)
                </span>
              </div>
              <button
                className="aav-btn"
                onClick={() => navigator.clipboard.writeText(a.url)}
                title="کپی لینک دانلود"
              >
                کپی لینک
              </button>
              <button
                className="aav-btn aav-btn--select"
                onClick={() => setForm(x => ({ ...x, apkUrl: a.url }))}
                title="استفاده در فرم انتشار"
              >
                انتخاب
              </button>
              <button
                className="aav-btn aav-btn--danger"
                onClick={() => del(a.filename)}
                title="حذف از سرور"
              >
                حذف
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* ===================== فرم انتشار ===================== */}
      <h3 className="aav-section-title">
        انتشار اعلام برای نسخه {APP_VERSION}
      </h3>
      <div className="aav-form">
        <textarea
          placeholder="پیام به کاربر (مثلاً: بهبود سرعت و رفع باگ)"
          value={form.message}
          onChange={e => setForm(x => ({ ...x, message: e.target.value }))}
          rows={3}
          maxLength={300}
        />
        <div style={{ fontSize: 11, color: '#9ca3af', textAlign: 'left' }}>
          {form.message.length} / 300
        </div>

        <label className="aav-checkbox-row">
          <input
            type="checkbox"
            checked={form.forceUpdate}
            onChange={e => setForm(x => ({ ...x, forceUpdate: e.target.checked }))}
          />
          به‌روزرسانی اجباری (کاربر تا نصب نکردن نمی‌تواند از برنامه استفاده کند)
        </label>

        <input
          type="text"
          placeholder="آدرس APK (از لیست بالا یا دستی)"
          value={form.apkUrl}
          onChange={e => setForm(x => ({ ...x, apkUrl: e.target.value }))}
        />

        <button
          className="aav-publish-btn"
          onClick={publish}
          disabled={!canPublish}
        >
          {busy ? 'در حال انتشار…' : 'انتشار برای کاربران'}
        </button>

        {versionMismatch && (
          <div style={{ fontSize: 12, color: '#b91c1c', textAlign: 'center' }}>
            تا زمانی که نسخه‌ی باندل شما با سرور یکی نباشد، دکمه غیرفعال است.
          </div>
        )}
      </div>
    </div>
  );
}